import { Temporal } from '@js-temporal/polyfill';

const instance = Temporal.Now.instant();

function getOffset(timeZone: string): number {
  const tz = instance.toZonedDateTimeISO(timeZone);
  return tz.offsetNanoseconds;
}

function getFormattedOffset(timeZone: string): string {
  const tz = instance.toZonedDateTimeISO(timeZone);
  return tz.offset;
}

export const DateTimeZoneHelper = {
  getOffset,
  getFormattedOffset
};
